<div class="inner-section-nav">
  <app-button buttonStyle="unstyled"
              class="inner-section-nav__nav-item"
              *ngFor="let item of options"
              [ngClass]="{
                        'inner-section-nav__nav-item--active': item.id === innerActiveOption
                      }"
              (click)="navigateTo.emit(item.id)">

    {{ item.title | t }}
  </app-button>
</div>
